module.exports = __webpack_public_path__ + "static/media/not-found.533ab57e.svg";